import { IHttpResponse } from "../common.interface";
import { httpGet, httpPatch } from '../http.service'


class AttendanceService {
	async fetchListing(params?: any) {
		return await httpGet<IHttpResponse<any>>(
			'api/v1/admin/attendance/pages',
			params,
		)
	}
	async fetchTodayListing(params?: any) {
		return await httpGet<IHttpResponse<any>>(
			'api/v1/admin/attendance/today',
			params,
		)
	}
	async update(params?: any) {
		return await httpPatch<any>(
			`api/v1/admin/attendance/${params?.id}`,
			params,
		)
	}
}

const attendanceService = new AttendanceService();
export { attendanceService };
